import { faIcon } from "@utils/faIcon"

import { Badge } from "@atoms"

import { OpenPurchaseOrdersBadgeProps } from "./OpenPurchaseOrdersBadge.types"

const icon = faIcon({ name: "shopping-basket", style: "regular" })

export default function OpenPurchaseOrdersBadge(props: OpenPurchaseOrdersBadgeProps) {
    const { count, size = "md" } = props

    // The badge is always shown — a missing count renders as "0 open".
    const total = count ?? 0

    return (
        <Badge size={size} variant="icon" icon={icon} tooltip={`Open POs\n${total}`}>
            {total} open
        </Badge>
    )
}
